import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  "data-tour": "settings-section",
  class: "settings-section"
}
const _hoisted_2 = {
  "data-tour": "settings-section:text",
  class: "settings-section__text"
}
const _hoisted_3 = { class: "settings-section__title" }
const _hoisted_4 = {
  key: 0,
  class: "settings-section__description"
}


export default {
  __name: 'SettingsSection',
  props: {
  title: { type: String, required: true },
  description: { type: String, default: '' },
  flush: { type: Boolean, default: false },
  plain: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(props.title), 1),
      (props.description || _ctx.$slots.description)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _renderSlot(_ctx.$slots, "description", {}, () => [
              _createTextVNode(_toDisplayString(props.description), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["settings-section__card", [props.flush && 'is-flush', props.plain && 'is-plain']])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

}